import React from "react";
import { View, StyleSheet, Image } from "react-native";
import routes from "../../navigation/routes";
import Logger from "../../common/utils/Logger";
import NtMaterialIcon from "../../components/NtMaterialIcon";
import NtText from "../../components/NtText";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import colors from "../../config/colors";
import { navigationRef } from "../../../App";
import NtNavigationBar from "../../root/components/NtNavigationBar";
import BaseWholesaleController from "./BaseWholesaleController";
import WholesaleNavigator from "../../navigation/WholesaleNavigator";
import NtNavigationPannel from "../../root/components/NtNavigationPannel";

class WholesaleRootController extends BaseWholesaleController {
  state = {
    currentController: null,
    isMobile: false,
    sidebarCollapsed: this.context.user?.ui
      ? this.context.user?.ui?.sidebarcollapsed
      : true,
  };

  options = [
    {
      icon: "home",
      title: "All Accounts",
      action: () => {
        navigationRef.current.navigate(routes.dashboard);
      },
      isSelected: () => {
        return (
          navigationRef.current?.getCurrentRoute()?.name == routes.dashboard
        );
      },
    },
    {
      icon: "tools",
      title: "Manage",
      action: () => {
        navigationRef.current.navigate(routes.wholesale, {
          deviceid: navigationRef.current?.getCurrentRoute()?.params?.deviceid,
        });
      },
      isSelected: () => {
        return (
          navigationRef.current?.getCurrentRoute()?.name == routes.wholesale
        );
      },
    },
    {
      icon: "pound",
      title: "Phone Numbers",
      action: () => {
        navigationRef.current.navigate(routes.did, {
          deviceid: navigationRef.current?.getCurrentRoute()?.params?.deviceid,
        });
      },
      isSelected: () => {
        return navigationRef.current?.getCurrentRoute()?.name == routes.did;
      },
    },
    {
      icon: "ip-network",
      title: "IP Whitelist",
      action: () => {
        navigationRef.current.navigate(routes.ip, {
          deviceid: navigationRef.current?.getCurrentRoute()?.params?.deviceid,
        });
      },
      isSelected: () => {
        return navigationRef.current?.getCurrentRoute()?.name == routes.ip;
      },
    },
  ];

  componentDidMount() {
    super.componentDidMount();
  }

  showSidePannel = () => {
    return true;
  };

  isPBXSelected = () => {
    let response = false;
    this.pbxItems.map((each) => {
      response = response || each.isSelected();
    });

    return response;
  };

  renderMenu = (item) => {
    const defaultIconSize = 22;

    if (item?.items) {
      return (
        <SubMenu
          key={item.title}
          icon={
            <NtMaterialIcon
              name={item.icon}
              color={colors.almostBlack}
              size={item.iconSize || defaultIconSize}
            />
          }
          style={{
            ...styles.menu,
            ...item.titleStyle,
            backgroundColor: item.isSelected() ? colors.lighestGray : null,
          }}
          label={item.title}
        >
          {item?.items?.map((each) => this.renderMenu(each))}
        </SubMenu>
      );
    } else {
      return (
        <MenuItem
          key={item.title}
          icon={
            item.icon ? (
              <NtMaterialIcon
                name={item.icon}
                color={colors.almostBlack}
                size={item.iconSize || defaultIconSize}
              />
            ) : null
          }
          onClick={() => {
            item.action();
          }}
          style={{
            ...styles.menu,
            ...item.titleStyle,
            backgroundColor: item?.isSelected() ? "white" : null,
          }}
        >
          {item.title}
        </MenuItem>
      );
    }
  };

  render() {
    return (
      <View style={styles.container}>
        <View style={{ flex: 1 }}>
          <NtNavigationBar />

          <View style={{ flex: 1, flexDirection: "row" }}>
            <NtNavigationPannel options={this.options} />

            <WholesaleNavigator
              onControllerChanged={(controller) => {
                Logger("Current controller: ", controller);
                this.setState({ currentController: controller });
              }}
            />
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    padding: 0,
    flex: 1,
  },
  menu: {
    fontFamily: "Helvetica",
    color: colors.almostBlack,
    fontWeight: "600",
    fontSize: 13,
  },
});

export default WholesaleRootController;
